import { retry } from "rxjs/operators";
import { Error } from "./model/fileError";

/**
 *
 * @param file This parameter takes file as input
 * @param callBack It has a callback function in which all the necessary values will get in order to upload the files
 */
export function uploadFiles(file, callBack) {
    const worker = new Worker(new URL('src/app/app.worker', import.meta.url), { type: 'module' });
    worker.onmessage = ({ data }) => {
        let obj = {
            name: data.name,
            size: data.size,
            extension: data.name.substring(data.name.lastIndexOf('.') + 1),
            content: data.result
        }
        callBack(obj);
    }
    worker.onerror = (err) => {
        ////console.log('erro uploading fiule', err);
    }
    worker.postMessage(file);
}

/**
 *
 * @param file Actual file that needs to be validated
 * @param size size of the file
 * @param allowedExtensions which extensions types are allowed
 */
export function validateFiles(file: File, size: number, allowedExtensions: Array<string>) {
    let errors : any[]=[];
    var filename = file.name;
    var extenvalue = (new RegExp('(' + allowedExtensions.join('|').replace(/\./g, '\\.') + ')$')).test(filename?.toLocaleLowerCase());
    var sizeMb = file.size / 1024 / 1024;
    let error: Error;
    if (extenvalue) {
        if (sizeMb > size) {
            error = {
                fileName: filename,
                error: "Please upload file less or equal to " + size + "MB."
            }
        } else{
            return errors;
        }
    } else {
        error = { fileName: filename, error: "Please upload valid file with extension "+allowedExtensions.toString() };
    }
    if (error) {
        errors.push(error);
    }
    return errors;
}

export function validateFileSize(file: File, size: number) {
    let errors : any[]=[];
    var filename = file.name;
    var sizeMb = file.size / 1024 / 1024;
    let error: Error;

    if (sizeMb > size) {
        error = {
            fileName: filename,
            error: "Please upload file less or equal to " + size + "MB."
        }

        if (error) {
            errors.push(error);
        }
    } else{
        return errors;
    }

    return errors;
}

export function addFiles(parentArr, childObj, ) {

}
